/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Online_Checkin_UnregisteredInputs */



/**
* | output |
* | --- |
* | "Registration is closed. Join the server and ask the organizer if you can still join." |
*
* @param {Tournament_Online_Checkin_UnregisteredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_online_checkin_unregistered = /** @type {((inputs?: Tournament_Online_Checkin_UnregisteredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Online_Checkin_UnregisteredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les inscriptions sont closes. Rejoignez le serveur et demandez à l'organisateur si vous pouvez encore participer.")
	if (locale === "es") return /** @type {LocalizedString} */ ("La inscripción está cerrada. Únase al servidor y pregunte al organizador si todavía puede participar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("A inscrição está encerrada. Entre no servidor e pergunte ao organizador se você ainda pode participar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le iscrizioni sono chiuse. Acceda al server e chieda all'organizzatore se può ancora partecipare.")
	return /** @type {LocalizedString} */ ("Registration is closed. Join the server and ask the organizer if you can still join.")
});